<template> 
    <div class="product-management">
      <div class="table-header">
        <h3>Arşivlenmiş Ürünler</h3>
        <div>
          <label>
            <input type="checkbox" v-model="showDeleteButtons" /> Silme Butonlarını Göster
          </label>
        </div>
        <input type="text" v-model="searchQuery" placeholder="Ürün adı ile ara..." />
      </div>
      <table> 
        <thead>
          <tr>
            <th>Seri Numarası</th>
            <th>Ürün Adı</th>
            <th>Açıklama</th>
            <th>Stok Miktarı</th>
            <th>Durum</th>
            <th>Oluşturulma Tarihi</th>
            <th>Kategori</th>
            <th>Arşivden Çıkar</th>
            <th v-if="showDeleteButtons">Sil</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in filteredProducts" :key="product.product_id">
            <td>#{{ product.product_serial }}</td>
            <td>{{ product.product_name }}</td>
            <td>{{ product.description }}</td>
            <td>{{ product.stock_amount }}</td>
            <td>
              <select v-model="product.status" @change="updateProductStatus(product)">
                <option value="Aktif">Aktif</option>
                <option value="İnaktif">İnaktif</option>
              </select>
            </td>
            <td>{{ formatDateTime(product.created_at) }}</td>
            <td>
              <button @click="openCategoryModal(product)">Ürün Kategorisi</button>
            </td>
            <td>
              <button @click="unarchiveProduct(product.product_id)">Arşivden Çıkar</button>
            </td>
            <td v-if="showDeleteButtons">
              <button class="deletebutton" @click="confirmDelete(product.product_id)">Sil</button>
            </td>
          </tr>
        </tbody>
      </table>
  
      <!-- Ürün Kategori Modal -->
      <ProductCategories
        v-if="showCategoryModal"
        :productId="selectedProductForCategory.product_id"
        :productName="selectedProductForCategory.product_name"
        @close="showCategoryModal = false"
      />
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import ProductCategories from "./ProductCategories.vue";  
  
  export default {
    components: {
      ProductCategories,
    },
    data() {
      return {
        products: [],
        showDeleteButtons: false,
        searchQuery: "", 
        showCategoryModal: false,
        selectedProductForCategory: {},
      };
    },
    computed: {
      filteredProducts() {
        return this.products.filter(product =>
          product.product_name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }
    },
    methods: {
      async fetchArchivedProducts() {
        try {
          const response = await axios.get("/admin/archivedproducts");
          this.products = response.data;
        } catch (error) {
          console.error("Arşivlenmiş ürünler alınırken hata oluştu:", error);
        }
      },
      openCategoryModal(product) {
        this.selectedProductForCategory = { ...product };
        this.showCategoryModal = true;
      },
      async updateProductStatus(product) {
        try {
          await axios.put(`/admin/products/${product.product_id}`, product);
          this.fetchArchivedProducts();
          alert("Ürün durumu başarıyla güncellendi.");
        } catch (error) {
          console.error("Ürün durumu güncellenirken hata oluştu:", error);
          alert("Ürün durumu güncellenirken bir hata oluştu.");
        }
      },
      async unarchiveProduct(product_id) {
        try {
          await axios.put(`/products/unarchive/${product_id}`);
          this.fetchArchivedProducts();
        } catch (error) {
          console.error("Ürün arşivden çıkarılırken hata oluştu:", error);
        }
      },
      async deleteProduct(product_id) {
        try {
          await axios.put(`/products/softdelete/${product_id}`);
          this.fetchArchivedProducts();
        } catch (error) {
          console.error("Ürün silinirken hata oluştu:", error);
        }
      },
      confirmDelete(product_id) {
        if (confirm("Bu ürünü silmek istediğinize emin misiniz?")) {
          this.deleteProduct(product_id);
        }
      }, 
    },
    mounted() {
      this.fetchArchivedProducts();
    },
  };
  </script>
  
<style>
.table-header{ display: flex; flex-direction: column;}
</style>